import { Country, defaultCountry } from './Country';

export interface Region {
    id: number;
    name: string;
    country_id: number;
    country?: Country;
}

export const defaultRegion: Region = {
    id: 0,
    name: '',
    country_id: 0,
    country: defaultCountry
};
